import { render, staticRenderFns } from "./section-inactive.component.html?vue&type=template&id=5b441cc4&scoped=true&"
import script from "./section-inactive.component.ts?vue&type=script&lang=ts&"
export * from "./section-inactive.component.ts?vue&type=script&lang=ts&"
import style0 from "./section-inactive.component.scss?vue&type=style&index=0&id=5b441cc4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b441cc4",
  null
  
)

export default component.exports